export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    yearsHeader = [],
    groups = [],
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const yearsHtml = yearsHeader.map((y) => `<th class="border text-center">${y}</th>`).join("");
  const columnsNumbersHtml = yearsHeader.map((_, idx) => `<th class="border text-center">${idx + 3}</th>`).join("");

  let rowsHtml = "";
  groups.forEach((group, gIdx) => {
    // Group Header
    rowsHtml += `
      <tr class="bg-light font-bold">
        <td class="border text-center">${gIdx + 1}</td>
        <td class="border" colspan="${3 + yearsHeader.length}" style="padding-left: 8px;">${group.affiliateName}</td>
      </tr>
    `;

    // Group Items
    group.items.forEach((item) => {
      const allocationsHtml = item.yearlyAllocations
        .map((val) => `<td class="border text-right px-1">${fmt(val)}</td>`)
        .join("");
      
      rowsHtml += `
        <tr>
          <td class="border text-center">${item.stt || ""}</td>
          <td class="border px-1">${item.content || ""}</td>
          <td class="border text-right px-1">${fmt(item.totalDifference)}</td>
          <td class="border text-center">${item.allocationPeriod || ""}</td>
          ${allocationsHtml}
        </tr>
      `;
    });

    // Group Total
    const totalsHtml = group.yearlyTotals
      .map((val) => `<td class="border text-right px-1 font-bold">${fmt(val)}</td>`)
      .join("");

    rowsHtml += `
      <tr class="font-bold underline">
        <td class="border"></td>
        <td class="border px-1 italic" colspan="3">Cộng số phân bổ hàng năm</td>
        ${totalsHtml}
      </tr>
    `;
  });

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S42b-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 30px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">SỔ THEO DÕI PHÂN BỔ CÁC KHOẢN CHÊNH LỆCH PHÁT SINH KHI MUA KHOẢN ĐẦU TƯ VÀO CÔNG TY LIÊN KẾT</h2>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="40">STT</th>
            <th class="border" rowspan="2">Nội dung phân bổ</th>
            <th class="border" rowspan="2" width="100">Tổng số chênh lệch</th>
            <th class="border" rowspan="2" width="100">Thời gian khấu hao (phân bổ)</th>
            <th class="border" colspan="${yearsHeader.length}">Năm</th>
          </tr>
          <tr>
            ${yearsHtml}
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">1</th>
            <th class="border">2</th>
            ${columnsNumbersHtml}
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div>- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div style="margin-top: 5px;">- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="33%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="33%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="33%">
            <div style="font-style: italic; font-size: 11px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .bg-light { background-color: #F9F9F9; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
      .italic { font-style: italic; }
      .underline { text-decoration: underline; }
    </style>
  `;
};
